<div class="profile-card">
  <div class="avatar-container">
    <span style="color: white; display: flex; justify-content: center;">
      <span><p-avatar icon="pi pi-user" styleClass="mr-2 bg-gray-300 fs-6" size="xlarge"
          shape="circle"></p-avatar></span>
    </span>
  </div>

  <h1 class="patient-name">{{ patientDate.fullName }}</h1>
  <p class="patient-mrn">
    MRN: {{ patientDate.mrn || 'N/A' }}
    <span class="mx-2" style="color: #e0e0e0">|</span>
    <span class="status-dot"
      [style.background-color]="(patientDate.patientInrStatus === 'MONITORED' || patientDate.patientInrStatus === 'ACTIVE') ? '#28a745' : '#6c757d'"></span>
    {{ patientDate.patientInrStatus || 'N/A' }}
  </p>

  <div class="details-grid">
    <div class="detail-item">
      <label>Gender</label>
      <p>{{ patientDate.gender || 'N/A' }}</p>
    </div>
    <div class="detail-item">
      <label>Date of Birth</label>
      <p>{{ patientDate.birthDate | date : 'dd/MM/yyyy' }}</p>
    </div>
    <div class="detail-item">
      <label>National ID</label>
      <p class="small">{{ patientDate.nationalId || 'N/A' }}</p>
    </div>
    <div class="detail-item">
      <label>Home Address</label>
      <p>{{ patientDate.address || 'N/A' }}</p>
    </div>
    <div class="detail-item">
      <label>Patient phone</label>
      <p>{{ patientDate.phoneNumber || 'N/A' }}</p>
    </div>
    <div class="detail-item">
      <label>Email Address</label>
      <p>{{ patientDate.email || 'N/A' }}</p>
    </div>
    <div class="detail-item">
      <label>Blood</label>
      <p>{{ patientDate.bloodType || 'N/A' }}</p>
    </div>
    <div class="detail-item">
      <label>Target INR</label>
      <p>{{ patientDate.targetInrResult || 'N/A' }}</p>
    </div>
    <div class="detail-item">
      <label>Target Dose</label>
      <p>{{ patientDate.targetMarivanDose ? patientDate.targetMarivanDose + ' mg' : 'N/A' }}</p>
    </div>
  </div>
</div>